import { type MethodStep } from "@reciperoll/core";

// Read-only method list for the recipe view: numbered steps that restart after
// each section heading (mirrors the RN recipe view + cook mode).
export function RecipeMethodView({ steps }: { steps: MethodStep[] }) {
  let n = 0;
  return (
    <div className="space-y-5 max-w-xl">
      {steps.map((s) => {
        if (s.group) {
          n = 0;
          return (
            <p
              key={s.id}
              className="text-sm font-bold uppercase tracking-wider text-ink-soft pt-2"
            >
              {s.instruction}
            </p>
          );
        }
        n += 1;
        return (
          <div key={s.id} className="flex gap-4">
            <span className="shrink-0 w-8 h-8 rounded-full bg-terracotta/10 text-terracotta font-bold text-sm flex items-center justify-center">
              {n}
            </span>
            <p className="flex-1 text-[15px] text-ink leading-relaxed pt-1 whitespace-pre-wrap">
              {s.instruction}
            </p>
          </div>
        );
      })}
    </div>
  );
}
